import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";
import React from "react";
import ListOfAgreementService from "./agreement-services-list";
import { IAgreementService } from "src/interface/IAgreementService";
import { IAgreement } from "src/interface/IAgreement";

const ShowAgreementInfo = ({
  open,
  handleClose,
  agreement: agreement,
}: {
  open: boolean;
  handleClose: () => void;
  agreement: IAgreement;
}) => {
  return (
    <React.Fragment>
      <Dialog open={open} onClose={handleClose} maxWidth="xl">
        <DialogTitle>
          قرار داد مشتری{" "}
          {agreement.customer?.fName + " " + agreement.customer?.lName}
        </DialogTitle>
        <DialogContent>
          <ListOfAgreementService rows={agreement} />
        </DialogContent>
        <DialogActions>
          <Button color="error" variant="contained" onClick={handleClose}>
            انصراف
          </Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
};

export default ShowAgreementInfo;
